import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { availableLanguages } from "lib/config";

// import Fetch from "i18next-fetch-backend";

import es from "assets/translations/es/translation.json";
import en from "assets/translations/en/translation.json";
import pt from "assets/translations/pt/translation.json";

i18n
  // .use(Fetch)
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    react: {
      defaultTransParent: "div",
    },
    returnEmptyString: false,
    fallbackLng: "es",
    whitelist: Object.keys(availableLanguages),
    debug: process.env.NODE_ENV === "development",
    keySeparator: ".", // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    // backend: { loadPath: "/translations/{{lng}}/{{ns}}.json" },

    resources: {
      en: { translation: en },
      es: { translation: es },
      pt: { translation: pt },
    },
    detection: { order: ["querystring", "localStorage", "navigator"] },
  });

export default i18n;
